module.exports = __webpack_public_path__ + "img/arrow-connection-icon.011962cb.svg";